import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiPublicGuideService } from '../../../core/services/api/PublicGuide/api-public-guide';
import { ManualContact } from '../../../core/models/manual-contact.model';
import { ManualHeroComponent } from '../manual-hero/manual-hero.component';

@Component({
  selector: 'app-manual-report',
  standalone: true,
  imports: [CommonModule, ManualHeroComponent],
  templateUrl: './manual-report.component.html',
  styleUrl: './manual-report.component.css',
})
export class ManualReportComponent implements OnInit, OnDestroy {
  private readonly api = inject(ApiPublicGuideService);
  private copiedTimer: ReturnType<typeof setTimeout> | null = null;

  contact = signal<ManualContact | null>(null);
  isLoading = signal(false);
  error = signal<string | null>(null);
  copied = signal(false);

  ngOnInit(): void {
    this.load();
  }

  ngOnDestroy(): void {
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
  }

  load(): void {
    this.isLoading.set(true);
    this.error.set(null);
    this.api.getPublicManualContact().subscribe({
      next: (c) => {
        this.contact.set(c);
        this.isLoading.set(false);
      },
      error: () => {
        this.error.set('โหลดข้อมูลติดต่อไม่สำเร็จ');
        this.isLoading.set(false);
      },
    });
  }

  telHref(phone: string): string {
    return 'tel:' + phone.replace(/[^\d+]/g, '');
  }

  mailHref(email: string): string {
    return 'mailto:' + email.trim();
  }

  async copyAddress(address: string | null | undefined): Promise<void> {
    const text = (address || '').trim();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const area = document.createElement('textarea');
      area.value = text;
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      document.execCommand('copy');
      document.body.removeChild(area);
    }
    this.copied.set(true);
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
    this.copiedTimer = setTimeout(() => this.copied.set(false), 2000);
  }
}
